import { render } from "./ModelPropertyValue.vue?vue&type=template&id=03e6c724&ts=true"
import script from "./ModelPropertyValue.vue?vue&type=script&lang=ts"
export * from "./ModelPropertyValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__